<!-- ====================== MODAL CONTAINER ====================== -->
<div class="modal-container" [ngClass]="{'minimized': minimized}">
  
  <!-- ====================== MODAL HEADER ====================== -->
  <div class="modal-header">
    <h3 class="modal-title">{{title}}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimized, 'fa-minus-square-o': !minimized}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimized = !minimized"></i>
      <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
    </div>
  </div>

  <!-- Issue Description -->
  @if (ISSUE_DESC) {
<table cellspacing="1" cellpadding="1" style="width:100%">
    <tr style="height:50px;">
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%;vertical-align:middle;text-align:left"><b>Issue: {{ISSUE_DESC}}</b></td>
    </tr>
  </table>
}

  <!-- ====================== MODAL BODY ====================== -->
  <div class="modal-body" [hidden]="minimized">
  
  <!-- LOADER -->
  @if (showFormLoader) {
<div class="row formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- MAIN FORM CONTENT -->
  @if (!showFormLoader) {
<div class="row">
    
    <!-- Entity Details Table -->
    <table class="table table-bordered form-inline enityDetails">
      <tr>
        @for (key of getObjectKeys(entityList); track $index) {
<td>
          <span>{{key}}</span>
        </td>
}
      </tr>
      <tr>
        @for (key of getObjectKeys(entityList); track $index) {
<td>
          <span>{{entityList[key]}}</span>
        </td>
}
      </tr>
    </table>

    <!-- Main Form Table -->
    <table class="table table-bordered form-inline">
      <thead>
        <tr>
          <th colspan="2">Partners' Distributive Share Items</th>
          <th colspan="1" class="subHeader">
            <span class="schd-ins">Total Amount</span>
          </th>
        </tr>
      </thead>
      
      <tbody>
        @for (row of formRows; track $index; let i = $index) {

          @if (shouldShowRow(row.num)) {
<tr>
            <!-- Line Number -->
            <td style="width: 58px">{{row.num}}</td>
            
            <!-- Description & Special Inputs -->
            <td>
              {{row.description}}
              
              <!-- 15d, 15e, 15f, 13c, 13d, 13d(1), 13e(1) - inline text inputs -->
              @if (row.num === '15d' && taxYear < 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[32].value1" type="text" maxlength="100">
}
              @if (row.num === '15e' && taxYear < 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[34].value1" type="text" maxlength="100">
}
              @if (row.num === '15f' && taxYear < 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[36].value1" type="text" maxlength="100">
}
              @if (row.num === '13c' && taxYear < 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[22].value1" type="text" maxlength="100">
}
              @if (row.num === '13d' && taxYear < 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[24].value1" type="text" maxlength="100">
}

              <!-- 2023+ specific inputs -->
              @if (row.num === '13d(1)' && taxYear >= 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[23].value1" type="text" maxlength="100">
}
              @if (row.num === '13e(1)' && taxYear >= 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[25].value1" type="text" maxlength="100">
}
              @if (row.num === '15d' && taxYear >= 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[33].value1" type="text" maxlength="100">
}
              @if (row.num === '15e' && taxYear >= 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[35].value1" type="text" maxlength="100">
}
              @if (row.num === '15f' && taxYear >= 2023) {
<input 
                     class="form-control input-md numText inline-input"
                     [(ngModel)]="formRows[37].value1" type="text" maxlength="100">
}

              <!-- 16p - Paid/Accrued checkboxes -->
              @if (row.num === '16p') {
<div class="inline-checkboxes">
                {{formRows[i-2]?.description}} &nbsp;
                <input type="checkbox" 
                       [(ngModel)]="formRows[i-2].value1"
                       (ngModelChange)="unselectOther(i-2, 'Paid')">
                &nbsp;&nbsp;
                {{formRows[i-1]?.description}} &nbsp;
                <input type="checkbox" 
                       [(ngModel)]="formRows[i-1].value1"
                       (ngModelChange)="unselectOther(i-1, 'Accrued')">
              </div>
}

              <!-- 16 - single checkbox -->
              @if (row.num === '16' && taxYear < 2025) {
<div class="inline-checkboxes">
                <input type="checkbox" 
                       [checked]="row.value1 === '1'"
                       (change)="setValue(i, row.value1)">
              </div>
}

              <!-- 16a, 16b - checkboxes -->
              @if (((row.num === '16a' || row.num === '16b') && taxYear >= 2025)) {
<div class="inline-checkboxes">
                <input type="checkbox" 
                       [checked]="row.value1 === '1'"
                       (change)="setValue(i, row.value1)">
              </div>
}

              <!-- 20c - Subtable with add/remove -->
              @if (row.num === '20c') {
<div class="subtable-container">
                <table class="subTable">
                  <thead>
                    <tr>
                      <th class="code-col">Code</th>
                      <th class="value-col">Value</th>
                      <th class="action-col">
                        <i class="fa fa-plus-circle color-green" style="cursor: pointer;" (click)="addRow()"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (subRow of subtableRows; track $index; let j = $index) {
<tr>
                      <td class="code-col">
                        <select class="form-control" [(ngModel)]="subRow.DATA_ATTRIB_A">
                          <option value="">Select</option>
                          @for (option of optionsList; track $index) {
<option [value]="option">{{option}}</option>
}
                        </select>
                      </td>
                      <td class="value-col">
                        <input type="text" class="form-control" [(ngModel)]="subRow.DATA_ATTRIB_B">
                      </td>
                      <td class="action-col">
                        <i class="fa fa-minus-circle color-red" style="cursor: pointer;" (click)="removeSubtableRow(j)"></i>
                      </td>
                    </tr>
}
                  </tbody>
                </table>
                @if (subtableRows.length === 0) {
<div class="noRecordsBlock">
                  <span>{{subtableString}}</span>
                </div>
}
              </div>
}
            </td>

            <!-- Value Column -->
            @if (!isEmptyValueCell(row.num)) {
<td style="width: 110px" align="right">
              <!-- Readonly for 6a, 9a -->
              @if (row.num === '6a' || row.num === '9a') {
<div>
                <input class="form-control input-md numText"
                       type="text" 
                       [disabled]="row.is_editable"
                       [ngModel]="row.value1 | number"
                       readonly>
              </div>
}
              <!-- Line 21 - always disabled -->
              @if (row.num === '21') {
<div>
                <input class="form-control input-md numText"
                       type="text"
                       disabled
                       [ngModel]="row.value1 | number">
              </div>
}
              <!-- Editable for others -->
              @if (row.num !== '6a' && row.num !== '9a' && row.num !== '21') {
<div>
                <input class="form-control input-md numText"
                       type="text"
                       [disabled]="row.is_editable"
                       [(ngModel)]="row.value1">
              </div>
}
            </td>
}

            <!-- Empty cell for certain rows -->
            @if (isEmptyValueCell(row.num)) {
<td style="width: 110px"></td>
}
          </tr>
}
        
}
      </tbody>
    </table>

    </div>
}
  </div>

  <!-- ====================== MODAL FOOTER ====================== -->
  <div class="modal-footer" [hidden]="minimized">
    <button class="save-button" type="button" (click)="save()" [disabled]="isSaving">
      @if (isSaving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="reset-button" type="button" (click)="reset()">Reset</button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>

</div> <!-- END modal-container -->
